export type TransactionItem = {
  method?: string;
  transaction_id?: string;
  reference_id?: string;
  merchant_reference?: string;
};

export const ROUTE_BY_REF: Record<string, (id: string) => string> = {
  'VIRTUAL ACCOUNT': (id) => `/virtual-account/${id}`,
  VA: (id) => `/virtual-account/${id}`,
  QRIS: (id) => `/qris-payment/${id}`,
  EWALLET: (id) => `/ewallet/${id}`,
  'E-WALLET': (id) => `/ewallet/${id}`,
  'INSTANT DEPOSIT': (id) => `/deposit-va/${id}`,
  CC: (id) => `/credit-card/${id}`,
  'DIRECT DEBIT': (id) => `/direct-debit/${id}`,
  DISBURSEMENT: (id) => `/disbursement/${id}`,
};
